import React from "react";
import PropTypes from "prop-types";

const GMSBorderlessButton = ({
  name = "",
  type = "button",
  onClick,
  id = "",
  color = "#091caa",
  disabled = false,
  fontSize = "13px",
  className = "",
  ...props
}) => {
  return (
    <div>
      <button
        type={type}
        className={`bg-transparent border-0 ${className}`}
        style={{ color: (disabled ? "#BAC0CA" : color),fontSize: fontSize,  }}
        id={id}
        onClick={onClick}
        // disabled={disabled}
      >
        {name}
      </button>
    </div>
  );
};

GMSBorderlessButton.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
};

export default GMSBorderlessButton;
